module.exports = __webpack_public_path__ + "img/m109.a5877b80.png";